export default __webpack_public_path__ + "static/media/carousel_security.823b159a.png";